import { render, staticRenderFns } from "./Kemikaalitiedot.vue?vue&type=template&id=2fbf536a&scoped=true"
import script from "./Kemikaalitiedot.vue?vue&type=script&lang=js"
export * from "./Kemikaalitiedot.vue?vue&type=script&lang=js"
import style0 from "./Kemikaalitiedot.vue?vue&type=style&index=0&id=2fbf536a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbf536a",
  null
  
)

export default component.exports